import React from 'react'
import NegotiationChild from './NegotiationChild'
export default () => <NegotiationChild />
